// Programme registry. Components import from here and never from a specific
// season file, so switching years is a one-line change below.
import * as season20262027 from "./2026-2027";

const SEASONS = [season20262027];

const activeSeason =
  SEASONS.find((season) => season.academicYear.active) || SEASONS[0];

export const academicYear = activeSeason.academicYear;
export const programs = activeSeason.programs;
export const kidsDays = activeSeason.kidsDays;
export const kidsLevels = activeSeason.kidsLevels;
export const kidsUpcomingLevels = activeSeason.kidsUpcomingLevels;

// "19:00" + "21:00" -> "19:00 - 21:00". Always rendered inside dir="ltr" so the
// range keeps its reading order in the RTL layout.
export function formatTimeRange(session) {
  if (!session) return "";
  return `${session.startTime} - ${session.endTime}`;
}

// Session of a level/programme for a given day column, or undefined.
export function sessionForDay(sessions, day) {
  return sessions.find((session) => session.day === day);
}

export default activeSeason;
